export enum PrivateMedialServiceNavParams {
   SETTLEMENT_SERVICE = 'uslugi-rozliczeniowe',
   RECEPTION_SERVICE = 'uslugi-recepcyjne',
   SERVICE_SETTINGS = 'ustawienia',
}

export const PRIVATE_MEDICAL_SERVICE_PATH = '/uslugi-prywatne';
